const p = {
  tracker: {
    production: "https://data-event-service.internalsizebay.com",
    development: "https://data-event-service-dev.internalsizebay.com"
  },
  aiImageService: {
    production: "https://ai-image-service.internalsizebay.com",
    development: "https://ai-image-service-dev.internalsizebay.com"
  },
  session: {
    production: "https://vfr-v3-production.sizebay.technology/api/me",
    development: "https://vfr-v3-staging.sizebay.eu/api/me"
  }
  // Adicione outros serviços conforme necessário
};
class l {
  constructor(t) {
    const e = t.env || "development";
    this.serviceOverrides = t.services || {}, this.endpoints = {};
    for (const s in p)
      if (Object.prototype.hasOwnProperty.call(p, s)) {
        const o = p[s][e];
        if (!o)
          continue;
        this.endpoints[s] = o;
      }
  }
  getEndpoint(t) {
    const e = this.endpoints[t];
    if (!e)
      throw new Error(
        `Endpoint for service '${t}' is not configured.`
      );
    return e;
  }
  getServiceConfig(t) {
    return this.serviceOverrides[t] || {};
  }
}
class S {
  constructor(t) {
    this.endpoint = t.getEndpoint("tracker");
  }
  async track(t, e) {
    const s = {
      eventName: t,
      ...e
    }, n = new URL(`${this.endpoint}/events`);
    try {
      const o = await fetch(n, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(s)
      });
      if (!o.ok) {
        const i = await o.text();
        throw new Error(`Request error: ${o.status} - ${i}`);
      }
      try {
        return await o.json();
      } catch {
        return {
          statusCode: 201,
          message: "Event successfully created."
        };
      }
    } catch (o) {
      throw o;
    }
  }
}
class c extends Error {
  constructor(t, e) {
    let s;
    try {
      const n = JSON.parse(e);
      s = (n == null ? void 0 : n.message) || e;
    } catch {
      s = e;
    }
    super(s), this.statusCode = t, this.details = e, Object.setPrototypeOf(this, c.prototype);
  }
}
async function a(r, t) {
  let e;
  try {
    e = await fetch(r, t);
  } catch (n) {
    throw new c(0, n.message);
  }
  const s = await e.text();
  if (!e.ok)
    throw new c(e.status, s);
  return JSON.parse(s);
}
class T {
  constructor(t) {
    this.endpoint = t.getEndpoint("aiImageService");
  }
  /**
   * Appends each non-null/undefined param to the given URL's query string.
   * @param url - The URL object to modify.
   * @param params - A record of key/value pairs to serialize.
   */
  appendQueryParams(t, e) {
    Object.entries(e).forEach(([s, n]) => {
      n != null && t.searchParams.append(s, String(n));
    });
  }
  /**
   * Fetches similar product recommendations by permalink or productId.
   *
   * Get similar products by product permalink or productId (at least one must be provided).
   * Sends a GET to `/recommendations/similar` with the given query parameters.
   *
   * @param params - parameters for the request. Either permalink or productId must be provided.
   * @returns Promise resolving to the parsed JSON response
   * @throws {ApiError} if the HTTP status is not 2xx or on network failure
   */
  getSimilarProducts(t) {
    const e = new URL(`${this.endpoint}/recommendations/similar`);
    return this.appendQueryParams(e, t), a(e.toString(), {
      method: "GET",
      headers: { "Content-Type": "application/json" }
    });
  }
  /**
   * Fetches complementary product recommendation pairs by permalink or productId.
   *
   * Get complementary products by product permalink or productId (at least one must be provided).
   * Sends a GET to `/recommendations/complementary` with the given query parameters.
   *
   * @param params - parameters for the request. Either permalink or productId must be provided.
   * @returns Promise resolving to the parsed JSON response
   * @throws {ApiError} if the HTTP status is not 2xx or on network failure
   */
  getComplementaryProducts(t) {
    const e = new URL(`${this.endpoint}/recommendations/complementary`);
    return this.appendQueryParams(e, t), a(e.toString(), {
      method: "GET",
      headers: { "Content-Type": "application/json" }
    });
  }
  /**
   * Fetches similar product recommendations by image.
   *
   * Sends a POST to `/image-search/similar` with the image data.
   *
   * @param payload - parameters for the request
   * @returns Promise resolving to the parsed JSON response
   * @throws {ApiError} if the HTTP status is not 2xx or on network failure
   */
  searchSimilarByImage(t) {
    const e = `${this.endpoint}/image-search/similar`;
    return a(e, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(t)
    });
  }
  /**
   * Fetches complementary product recommendations by image.
   *
   * Sends a POST to `/image-search/complementary` with the image data.
   *
   * @param payload - parameters for the request
   * @returns Promise resolving to the parsed JSON response
   * @throws {ApiError} if the HTTP status is not 2xx or on network failure
   */
  searchComplementaryByImage(t) {
    const e = `${this.endpoint}/image-search/complementary`;
    return a(e, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(t)
    });
  }
}
class u {
  constructor(t) {
    this.sid = null, this.sessionId = null;
    const e = t.getEndpoint("session");
    this.sessionEndpoint = `${e}/`, this.profileEndpoint = `${e}/user/profile`;
  }
  /**
   * Retrieves (or reuses) the session context, containing:
   *  - sid       := user_id
   *  - sessionId
   *
   * If not already cached, it will fetch them from the session endpoint.
   *
   * @returns {Promise<SessionContext>} The session context with sid and sessionId
   * @throws {Error} If the HTTP request fails
   */
  async getSessionInfo() {
    if (this.sid && this.sessionId !== null)
      return { sid: this.sid, sessionId: this.sessionId };
    const t = await fetch(this.sessionEndpoint, {
      credentials: "include"
    });
    if (!t.ok) {
      const s = await t.text();
      throw new Error(
        `Failed to fetch session info: ${t.status} – ${s}`
      );
    }
    const e = await t.json();
    return this.sid = e.catalogUser.id, this.sessionId = e.sessionId, { sid: this.sid, sessionId: this.sessionId };
  }
  /**
   * Sends the session profile payload to the server.
   *
   * @param payload – the profile data to send
   * @param sid     – optional: if you already have the sid, pass it here;
   *                  otherwise it will be retrieved via getSessionInfo()
   * @throws {Error} If the HTTP request fails
   */
  async sendProfile(t, e) {
    const s = e ?? (await this.getSessionInfo()).sid, n = new URL(this.profileEndpoint);
    n.searchParams.set("sid", s);
    const o = await fetch(n.toString(), {
      credentials: "include",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: s, id: null, ...t })
    });
    if (!o.ok) {
      const i = await o.text();
      throw new Error(
        `Failed to send profile: ${o.status} – ${i}`
      );
    }
  }
}
const O = [
  S,
  T,
  u
];
function E(r = {}) {
  const t = new l(r), e = O.map((n) => new n(t)), s = {};
  return e.forEach((n) => {
    [
      ...Object.getOwnPropertyNames(n),
      ...Object.getOwnPropertyNames(Object.getPrototypeOf(n))
    ].forEach((i) => {
      if (i === "constructor") return;
      const d = n[i];
      typeof d == "function" && (s[i] || (s[i] = (...h) => d.apply(n, h)));
    });
  }), s;
}
const m = {
  TOP: "TOP",
  BOTTOM: "BOTTOM",
  SHOE_ACCESSORY: "SHOE_ACCESSORY",
  FULL_BODY: "FULL_BODY",
  UNDERWEAR_FULL_BODY: "UNDERWEAR_FULL_BODY",
  UNDERWEAR_BOTTOM: "UNDERWEAR_BOTTOM",
  UNDERWEAR_TOP: "UNDERWEAR_TOP",
  WETSUIT_FULL_BODY: "WETSUIT_FULL_BODY",
  WETSUIT_BOTTOM: "WETSUIT_BOTTOM",
  WETSUIT_TOP: "WETSUIT_TOP"
}, f = {
  T_SHIRT: "t-shirt",
  SHIRT: "shirt",
  BLOUSE: "blouse",
  SWEATER: "sweater",
  HOODIE: "hoodie",
  JACKET: "jacket",
  COAT: "coat",
  CARDIGAN: "cardigan",
  BLAZER: "blazer",
  VEST: "vest",
  SWEATSHIRT: "sweatshirt",
  POLO_SHIRT: "polo shirt",
  TANK_TOP: "tank top",
  SKIRT: "skirt",
  TROUSERS: "trousers",
  JEANS: "jeans",
  SHORTS: "shorts",
  SNEAKERS: "sneakers",
  RUNNING_SHOES: "running shoes",
  BOOTS: "boots",
  ANKLE_BOOTS: "ankle boots",
  HIGH_HEELS: "high heels",
  FLATS: "flats",
  LOAFERS: "loafers",
  OXFORDS: "oxfords",
  SLIPPERS: "slippers",
  SANDALS: "sandals",
  DRESS: "dress",
  JUMPSUIT: "jumpsuit",
  SUIT: "suit",
  PANTIES: "panties",
  BRA: "bra",
  BIKINI: "bikini",
  BRIEFS: "briefs",
  BOXERS: "boxers",
  THONG: "thong",
  SWIMSUIT: "swimsuit",
  ONE_PIECE_SWIMSUIT: "one-piece swimsuit",
  WETSUIT: "wetsuit"
};
export {
  m as ClothType,
  f as ProductClass,
  E as createClient
};
